import * as React from 'react';

import cn from 'classnames';

import { Translate } from '@decorators';

import { IconBrandLogogram } from '@icons';

import { EBrandFileName } from '../../enums';
import { IBrandPageProps } from '../../types';
import { BrandBaseLogoScreen } from '../BrandBaseLogoScreen';

import * as s from './BrandLogogramScreen.scss';

@Translate('common.containers.Brand.components.BrandLogogramScreen')
export class BrandLogogramScreen extends React.Component<IBrandPageProps> {

	render() {
		const {
			isMobile,
			brand: {
				fileSizes: {
					logogram: fileSizes,
				},
			},
			urls: {
				brandDownload,
			},
			classNames: {
				card: cardClassName,
			},
			onDownloadButtonClick,
		} = this.props;

		return (
			<BrandBaseLogoScreen
				downloadFileSizes={isMobile ? null : fileSizes}
				downloadLinkUrls={{
					color: `${brandDownload}/${EBrandFileName.LOGOGRAM_COLOR}.zip`,
					grayScale: `${brandDownload}/${EBrandFileName.LOGOGRAM_GRAYSCALE}.zip`,
				}}
				colorTitle={this.t('colorVersion')}
				grayScaleTitle={this.t('grayscaleVersion')}
				downloadTitle={this.t('download')}
				icon={IconBrandLogogram}
				classNames={{
					card: cn(s.logogramCard, cardClassName),
				}}
				onDownloadButtonClick={onDownloadButtonClick}
			/>
		);
	}

}
